module.exports = __webpack_public_path__ + "d8bceae99b0f634bf0ff1479dc4fce34.pdf";